import React, {useContext, useEffect, useState} from "react";
import {Button, Layout, Card} from "@shopify/polaris";
import axios from "../axios";
import {createApp} from "@shopify/app-bridge";
import {Redirect} from "@shopify/app-bridge/actions";
import {ShopContext} from "../App";
import _ from "lodash";
import Br from "./Br";

const AppSubscribe = ({
                          hasActiveSubscription,
                          setHasActiveSubscription,
                          setLoadingSubscription,
                          show = false
                      }) => {
    const config = useContext(ShopContext);
    const [loading, setLoading] = useState(false);
    const [cancellingSubscription, setCancellingSubscription] = useState(false);
    const subscribeForBilling = () => {
        setLoading(true);
        setLoadingSubscription(true);
        axios.get(`/billing/recurring`, {
            "headers": {
                shopOrigin: config.shopOrigin,
                xShopHost: config.host,
            }
        }).then((response) => {
            if (response.success) {
                const app = createApp({
                    apiKey: process.env.REACT_APP_SHOPIFY_API_KEY,
                    host: config.host
                });
                Redirect.create(app).dispatch(Redirect.Action.REMOTE, response.conformation_url);
            }
            setLoading(false);
            setLoadingSubscription(false);
        }).catch((error) => {
            setLoading(false);
            setLoadingSubscription(false);
        });
    }
    const cancelSubscription = () => {
        setCancellingSubscription(true);
        axios.get(`/billing/cancel-recurring`, {
            "headers": {
                shopOrigin: config.shopOrigin,
                xShopHost: config.host,
            }
        }).then((response) => {
            setHasActiveSubscription(false);
            setCancellingSubscription(false);
        }).catch((error) => {
            setCancellingSubscription(false);
        });
    }
    useEffect(() => {
        setLoading(true);
        axios.get(`/billing/details`, {
            "headers": {
                shopOrigin: config.shopOrigin,
                xShopHost: config.host,
            }
        }).then((response) => {
            let hasSubscription = _.get(response, 'details.has_active_subscription', false);
            setHasActiveSubscription(hasSubscription);
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
        });
    }, [config, setHasActiveSubscription])
    if (hasActiveSubscription && !show) {
        return null
    }
    return (
        <div className="flex-row-space-evenly">
            <div>
                <Card sectioned>
                    <div className="plan-name">FREE</div>
                    <Br height={10}/>
                    <div>
                        <p><span className="pricingCurrencySymbol">$</span><span className="pricingPrice">0</span>&nbsp;
                            <span
                                className="pricingFrequency">/ month</span></p>
                    </div>
                    <Br height={20}/>
                    <div className="pricingList">
                        <p>Unlimited Manual Cart Recovery messages </p>
                        <p>Templates for manual messages </p>
                        <p>Abandoned Checkout tracking & management </p>
                        <p>WhatsApp Chat</p>
                    </div>
                    <Br height={50}/>
                    {hasActiveSubscription &&
                    <Button secondary onClick={cancelSubscription} disabled={(cancellingSubscription)}
                            loading={cancellingSubscription}>Downgrade</Button>}
                </Card>
            </div>
            <div>
                <Card sectioned>
                    <div className="plan-name">STARTER</div>
                    <Br height={10}/>
                    <div>
                        <p><span className="pricingCurrencySymbol">$</span><span className="pricingPrice">9</span>&nbsp;
                            <span
                                className="pricingFrequency">/ month</span></p>
                    </div>
                    <Br height={20}/>
                    <p>+ <a
                        href="https://docs.google.com/spreadsheets/d/1S_HvAcQXzekTl9JfH18iRljZfCeJnNJbvQaOoB8-Fic/edit?usp=sharing"
                        target='_blank'>cost of message</a> <br/><small>( Automated message rates vary by country and
                        start at $0.02
                        per message)</small></p>
                    <div className="pricingList">
                        <p>Free+ </p>
                        <p>AUTOMATED Abandoned Cart Recovery </p>
                        <p>AUTOMATED Confirmation & Delivery messages</p>
                        <p>Order CRM - Order confirmation, order delivery</p>
                        <p>Drip Automation: Send messages at different intervals </p>
                        <p>WhatsApp approved message templates</p>
                        <p>Dynamic coupon codes for automated messages </p>
                        <p>Priority Customer Support</p>
                    </div>
                    <Br height={20}/>
                    <Button primary onClick={subscribeForBilling} disabled={(loading || hasActiveSubscription)}
                            loading={loading}>{hasActiveSubscription ? 'Subscribed' : 'Upgrade'}</Button>
                    <Br height={10}/>
                    <p>Try it free for 14 days</p>
                </Card>
            </div>
        </div>
    );
}
export default AppSubscribe;
